import React, { useCallback } from 'react';
import { UploadOutlined } from '@ant-design/icons';
import { css } from '@emotion/css';
import { Button } from 'antd';

import useI18n from 'lib/hooks/useI18n';

import ExportJsonExcel from './js-export-excel';

const uploadIconStyle = css`
  margin-right: 0 !important;
  font-size: 14px;
`;

type ExportExcelProps = {
  sheetData: Record<string, any>[]; //excel文件中的数据源
  sheetName: string; //excel文件中sheet页名称
  sheetFilter: string[]; //excel文件中需显示的列数据
  sheetHeader: string[]; //excel文件中每列的表头名称
};

export type OptionProps = {
  fileName: string;
  data: ExportExcelProps;
};

const ExportExcel: React.FC<ExportExcelProps> = props => {
  const { sheetHeader, sheetFilter, sheetData, sheetName } = props;
  const { t } = useI18n();

  const exportExcel = useCallback(async () => {
    const option = {} as OptionProps;
    option.fileName = sheetName; //excel文件名称
    option.data = {
      sheetData,
      sheetName,
      sheetFilter,
      sheetHeader,
    };
    const toExcel = ExportJsonExcel(option);
    toExcel.saveExcel();
  }, [sheetHeader, sheetFilter, sheetData, sheetName]);

  return (
    <Button onClick={exportExcel} icon={<UploadOutlined className={uploadIconStyle} />}>
      {t('global.export')}
    </Button>
  );
};

export default ExportExcel;
